import axios from "axios";
import toast from "react-hot-toast";

export const API_BASE_URL = "https://stu149296.webhosting.arden.ac.uk/COM6008";

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000, // 10 seconds timeout
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Server responded with error
      switch (error.response.status) {
        case 401:
          // Only handle unauthorized errors if we're not on the login page
          if (!window.location.pathname.includes('/login')) {
            localStorage.clear();
            window.location.href = '/login';
          }
          break;
        case 403:
          // Only handle forbidden errors if we're not already on the profile page
          if (localStorage.getItem('role') !== 'admin' && !window.location.pathname.includes('/profile')) {
            window.location.href = '/profile';
          }
          break;
        default:
          // Handle other error statuses
          break;
      }
    } else if (error.request) {
      // Request made but no response
      console.error('No response received:', error.request);
    } else {
      // Error in request configuration
      console.error('Error setting up request:', error.message);
    }
    return Promise.reject(error);
  }
);

// Verify token on app startup
const verifyToken = async () => {
  const token = localStorage.getItem('token');
  if (token && !window.location.pathname.includes('/login')) {
    try {
      await api.get('/api/user-profile');
    } catch (error) {
      // If token verification fails, clear storage and redirect to login
      localStorage.clear();
      window.location.href = '/login';
    }
  }
};

// Run token verification
verifyToken();

export default api;
